import { useState } from 'react';
import { readerPosts, type ReaderPost } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

function ReaderCard({ post }: { post: ReaderPost }) {
  const [liked, setLiked] = useState(false);
  return (
    <article className="relative flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-600">
            <i className="ri-megaphone-fill" aria-hidden="true"></i>
          </span>
          <div className="leading-tight">
            <p className="flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
              {post.author}
              {post.verified && (
                <i className="ri-verified-badge-fill text-accent-500" aria-label="已核实来稿"></i>
              )}
            </p>
            <p className="text-xs text-foreground-700">{post.time}</p>
          </div>
        </div>
        <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-900">
          {post.badge}
        </span>
      </div>

      <h3 className="mt-4 font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
        {post.title}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{post.text}</p>

      <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-700">
        <button
          type="button"
          onClick={() => setLiked((v) => !v)}
          className={`inline-flex items-center gap-1.5 font-medium transition-colors ${
            liked ? 'text-primary-600' : 'hover:text-primary-600'
          }`}
        >
          <i className={liked ? 'ri-heart-fill' : 'ri-heart-line'} aria-hidden="true"></i>
          {post.likes}
        </button>
        <span className="inline-flex items-center gap-1">
          <i className="ri-chat-3-line" aria-hidden="true"></i>
          {post.comments} 讨论
        </span>
        <button
          type="button"
          className="ml-auto inline-flex items-center gap-1 font-medium text-primary-600 hover:text-primary-700"
        >
          展开聊聊 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </button>
      </div>
    </article>
  );
}

export default function Reader() {
  return (
    <section id="crowd" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8 py-16 md:py-20">
        <SectionHeading
          eyebrow="粉丝来稿"
          title="把话筒交给"
          accentWord="认真吃瓜的你"
          desc="每一条来稿都经过审核与脱敏处理。看过的现场、踩过的坑、扒出的细节，投稿分享，你的声音也能上头条。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {readerPosts.map((p) => (
            <ReaderCard key={p.id} post={p} />
          ))}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-2xl bg-primary-500 px-6 py-6 md:px-8">
          <div className="text-center sm:text-left">
            <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">
              手上刚好有个瓜？不如交给编辑部。
            </h3>
            <p className="mt-1 text-sm text-background-100">
              填好来料，审核通过后有机会登上头条，也会出现在上面这些推荐位。
            </p>
          </div>
          <a
            href="#submit"
            className="whitespace-nowrap inline-flex shrink-0 items-center justify-center gap-2 rounded-md bg-background-50 px-5 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-accent-500 hover:text-background-50"
          >
            <i className="ri-send-plane-fill" aria-hidden="true"></i>马上投稿
          </a>
        </div>
      </div>
    </section>
  );
}